<template lang="pug">
  div(
    v-if="tituloPronto && $route.name === 'informacoesCadastro'"
  ).card-info
    app-modal-visualiza-pdf(
      v-if="showModalVisualizaPdf",
      @closeModal="showModalVisualizaPdf = false",
      :titulo="this.tituloOrCertidao.tipo",
      :tipo="'TITULO_CERTIDAO'",
      :conteudo="conteudoModal"
    )
    el-row
      div.d-flex.tb
        span.verde-text.center {{`${this.tituloOrCertidao.proNome} ${this.tituloOrCertidao.info} está disponível! `}}
        el-button.green.textButtonBreak(
          tipo="success",
          @click="showModalVisualizaPdf = true"
        )
          span.center
            i.fal.fa-eye
            | &nbsp {{`Visualizar informações do(a) ${this.tituloOrCertidao.info}`}}

</template>

<script>
import { mapActions } from 'vuex'
import AppModalVisualizaPdf from '@/screens/analise/components/AppModalVisualizaPdf'

export default {
  components: {
    AppModalVisualizaPdf
  },

  data () {
    return {
      showModalVisualizaPdf: false,
      conteudoModal: null,
      tituloPronto: false,
      tituloOrCertidao: '',
      idProcesso: null
    }
  },
  beforeMount () {
    this.idProcesso = this.$route.params.id
  },

  async mounted () {
    if (this.idProcesso) {
      const titulo = await this.getTitulo(this.idProcesso)
      if (titulo && titulo.id) {
        this.conteudoModal = titulo.id
        this.tituloPronto = JSON.parse(titulo.tituloDespacho.tituloProcesso).entregue
        this.tituloOrCertidao = titulo.processo.tipo.codigo !== 'CERTIDAO_TITULO' ? { proNome: 'Seu', tipo: 'Título', info: 'título' } : { proNome: 'Sua', tipo: 'Certidão', info: 'certidão' }
      }
    }
  },

  methods: {
    ...mapActions({
      uploadAnexo: 'upload/uploadAnexo',
      getTitulo: 'processo/getTitulo'
    })
  }

}
</script>

<style scoped lang="scss">
.card-info {
  border-radius: 15px;
  background-color: #fff;
  border: solid 1px #009d64;
  margin: 2%;
  margin-bottom: -10px;
}

.d-flex {
  display: flex;
  justify-content: space-between;
}

.tb {
  margin-top: 40px;
  margin-bottom: 40px;
  padding-left: 20px;
  padding-right: 20px;
}

.verde-text {
  color: #009d64 !important;
}

.green {
  color: #ffffff;
  background-color: #009f61;
}

.textButtonBreak {
  white-space: break-spaces;
}

.center {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/screens/central/processos/AppDownloadTitulo.vue